import { onError } from '@apollo/client/link/error'
import { emitUnauthorizedRequest } from './utils/unauthorizedRequest.utils'
import { errorCodes } from '../../api/utils/apollo/errors/errorCodes'
import { type GraphQLFormattedError } from 'graphql'
import { camelCase } from 'change-case'

const SUPPORTED_REJECT_DETAIL_KEYS = ['noPartnerWriteAccess']

/**
 * Check if theres an error which contains a supported rejectDetails key:
 * {
 *   rejectDetails: {
 *     noPartnerWriteAccess: {
 *       partnerDetails: [{ name: 'partner1', id: 1 }, { name: 'partner2', id: 2 }]
 *     },
 *   }
 * }
 */
const getGraphQLErrorRejectDetails = (graphQLErrors: ReadonlyArray<GraphQLFormattedError>) => {
  const unauthorizedGraphQLError = graphQLErrors?.find(error => {
    if (error.extensions?.code !== errorCodes.NOT_AUTHORIZED) {
      return false
    }

    const rejectDetailsObject = error.extensions?.reject_details || error.extensions?.rejectDetails

    if (!rejectDetailsObject || typeof rejectDetailsObject !== 'object') {
      return false
    }

    return Object.keys(rejectDetailsObject).some(
      key => key && SUPPORTED_REJECT_DETAIL_KEYS.includes(camelCase(key))
    )
  })

  if (!unauthorizedGraphQLError) {
    return null
  }

  return (
    unauthorizedGraphQLError.extensions?.rejectDetails ||
    // @ts-expect-error TS18048 — strictNullChecks. TODO: fix strict null check
    unauthorizedGraphQLError.extensions.reject_details
  )
}

export const unauthorizedRequestLink = onError(({ graphQLErrors }) => {
  // @ts-expect-error TS2345 — strictNullChecks. TODO: fix strict null check
  const rejectDetails = getGraphQLErrorRejectDetails(graphQLErrors)

  if (rejectDetails) {
    Object.keys(rejectDetails as Record<string, any>).forEach(key => {
      if (camelCase(key) === 'noPartnerWriteAccess') {
        const details = (rejectDetails as Record<string, any>)[key]
        const partnerNames = details?.partnerDetails?.map((p: { name: string }) => p.name) || []
        const partnerIds = details?.partnerDetails?.map((p: { id: string | number }) => p.id) || []

        emitUnauthorizedRequest('partnerWriteAccessError', {
          partnerNames,
          partnerIds,
        })
      }
    })
  }
})
